module.exports = __webpack_public_path__ + "img/global-settings.f5d37da2.svg";